module.exports = __webpack_public_path__ + "img/pålestikk_double3.9ba86c26.jpg";